import { Dialog, DialogTitle, DialogContent, Button, DialogActions } from "@mui/material";
import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import TextField from "../../../../components/form/TextField";
import { useSaveQueryMutation } from "../../../../api/dataWranglerApiSlice";
import { useSelector } from "react-redux";
import { selectAdvancedFields } from "../../dataWranglerSlice";

interface Props {
    open: boolean;
    close: () => void;
}

interface FormValues {
    title: string;
    description: string;
}

const ADWSaveQuery = (props: Props) => {

    const advancedFields = useSelector(selectAdvancedFields);

    const { control, handleSubmit, formState: { errors }, resetField } = useForm<FormValues>({
        defaultValues: {
            title: "",
            description: ""
        }
    });
    const [saveQuery] = useSaveQueryMutation();
    const [clickedSaved, setClickedSaved] = useState(false);

    const getAdvancedFields = (advancedFields: Record<string, any>) => {
        return Object.keys(advancedFields || {}).reduce((acc: Record<string, any>, instrumentName) => {
            const { name, ageGroups, fields } = advancedFields[instrumentName];
            acc[instrumentName] = {
                name,
                ageGroups,
                fields: Object.keys(fields || {}).reduce((fieldAcc: Record<string, any>, fieldName) => {
                    fieldAcc[fieldName] = {};
                    return fieldAcc;
                }, {})
            };
            return acc;
        }, {});
    };

    const onSubmit = async (newData: FormValues) => {
        try {
            setClickedSaved(true)
            const results = getAdvancedFields(advancedFields);
            await saveQuery({
                title: newData.title,
                description: newData.description,
                type: 'private',
                builder: 'advanced',
                query: {
                    ...results,
                }
            });
            resetField('title');
            resetField('description');
            props.close()
            setClickedSaved(false)
        } catch (error) {
            console.error("SAVE ERROR", error);
        }
    }

    const onCancel = () => {
        setClickedSaved(true)
        resetField('title');
        resetField('description');
        props.close();
        setClickedSaved(false)
    }

    return (
        <Dialog
            open={props.open}
            onClose={props.close}
            fullWidth={true}
            maxWidth={'sm'}
        >
            <DialogTitle>Save Query</DialogTitle>
            <DialogContent>
                <form
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        minWidth: 356,
                    }}
                >
                    <Controller
                        name={"title"}
                        control={control}
                        rules={{
                            required: true,
                            pattern: /^(\s+\S+\s*)*(?!\s).*$/,
                            maxLength: {
                                value: 100,
                                message: 'Title should be 100 characters or less'
                            }
                        }}
                        render={({ field }) => (
                            <TextField
                                label={"Details"}
                                required={true}
                                error={errors.title ? true : false}
                                errorMessage={errors.title?.message}
                                {...field}
                            />
                        )}
                    />
                    <Controller
                        name={"description"}
                        control={control}
                        rules={{
                            required: true,
                            pattern: /^(\s+\S+\s*)*(?!\s).*$/,
                            maxLength: {
                                value: 255,
                                message: 'Description should be 255 characters or less'
                            }
                        }}
                        render={({ field }) => (
                            <TextField
                                label={"Description"}
                                required={true}
                                textBox={true}
                                error={errors.description ? true : false}
                                errorMessage={errors.description?.message}
                                {...field}
                            />
                        )}
                    />
                </form>
            </DialogContent>
            <DialogActions>
                <Button disabled={clickedSaved} onClick={onCancel}>Cancel</Button>
                <Button disabled={clickedSaved} onClick={handleSubmit(onSubmit)}>Save</Button>
            </DialogActions>
        </Dialog>
    )
}

export default ADWSaveQuery;